import type { ProbKey } from './keys';

export const ro: Partial<Record<ProbKey, string>> = {
  'app.eyebrow': 'Matematică · Probabilități',
  'app.title': 'Probabilități',
  'panel.experiment': 'Experiment',
  'panel.params': 'Parametri',
  'hint.line1': 'Alege un experiment, mișcă glisierele, urmărește cum se schimbă distribuția.',
  'hint.line2': 'Conținutul educațional trăiește în probabilități, nu în text.',
  'experiment.sample-space-lab.label': 'Spațiu de eșantionare',
  'experiment.sample-space-lab.info':
    'Explorează spații de eșantionare și calculează probabilități',
  'experiment.conditional-bayes.label': 'Condițional & Bayes',
  'experiment.conditional-bayes.info': 'Explorează probabilitatea condițională și teorema Bayes',
  'experiment.random-variables.label': 'Variabile aleatoare',
  'experiment.named-distributions.label': 'Distribuții cunoscute',
  'experiment.galton-board.label': 'Plansa Galton',
  'experiment.sums-of-iid.label': 'Sume i.i.d.',
  'experiment.normal-calculator.label': 'Calculator normal',
  'experiment.classic-problems.label': 'Probleme clasice',
  'submode.conditional-bayes.tree.label': 'Arbore',
  'submode.conditional-bayes.flowchart.label': 'Diagramă flux',
  'param.submode.label': 'Sub-mod',
  'param.preset.label': 'Prezentare',
  'param.prior.label': 'Probabilitate anterioară',
  'param.sensitivity.label': 'Sensibilitate (rata de adevăr pozitiv)',
  'param.false-positive-rate.label': 'Rata fals pozitiv',
  'param.show-formula-trace.label': 'Arată formula Bayes',
  'preset.conditional-bayes.medical-test.label': 'Test medical',
  'preset.conditional-bayes.spam-filter.label': 'Filtru spam',
  'preset.conditional-bayes.monty-hall-as-bayes.label': 'Monty Hall ca Bayes',
  'preset.conditional-bayes.draw-without-replacement.label': 'Extragere fără înlocuire',
  'preset.conditional-bayes.coin-coin.label': 'Monedă de două ori',
  'preset.conditional-bayes.custom-2level.label': 'Personalizat 2-nivel',
  'preset.conditional-bayes.custom-3level.label': 'Personalizat 3-nivel',
  'btn.reset-preset': 'Resetează prezentare',
  'btn.step-animation': 'Pas animație',
  'stat.prior': 'Anterior',
  'stat.posterior': 'Posterior',
  'stat.likelihood': 'Plauzibilitate',
  'formula.bayes.statement': 'Teorema Bayes',
  'message.siblings-sum-to-one': 'Probabilitățile se adună la 1',
  'experiment.random-variables.info': 'Explorează distribuții de probabilitate prin eșantionare',
  'submode.random-variables.2d6-sum.label': 'Suma a două zaruri',
  'submode.random-variables.2d6-diff.label': 'Diferență absolută a două zaruri',
  'submode.random-variables.2d6-max.label': 'Maximul a două zaruri',
  'submode.random-variables.coin-flips-count.label': 'Numărul de steme în 5 aruncări',
  'btn.reset': 'Resetare',
  'stat.expectation': 'E[X]',
  'stat.stdev': 'σ[X]',
  'stat.sample-count': 'Eșantioane',
  'experiment.named-distributions.info':
    'Explorează distribuții binomiale, geometrice, Poisson și hipergeometrice',
  'submode.named-distributions.binomial.label': 'Binomial',
  'submode.named-distributions.geometric.label': 'Geometric',
  'submode.named-distributions.poisson.label': 'Poisson',
  'submode.named-distributions.hypergeometric.label': 'Hipergeometric',
  'param.n.label': 'Numărul de încercări (n)',
  'param.p.label': 'Probabilitate (p)',
  'param.lambda.label': 'Rată (λ)',
  'param.N-population.label': 'Dimensiunea populației (N)',
  'param.K-successes.label': 'Numărul de succese (K)',
  'param.show-cdf.label': 'Arată CDF',
  'param.show-moments.label': 'Arată media și ±σ',
  'param.show-pascal-row.label': 'Arată rândul triunghiului Pascal',
  'param.compare-to.label': 'Compară cu...',
  'experiment.galton-board.info':
    'Simulează margele căzând prin o tablă Galton pentru a explora distribuția binomială',
  'param.rows.label': 'Numărul de rânduri',
  'param.show-binomial-theoretical.label': 'Arată binomul teoretic',
  'param.show-normal-approx.label': 'Arată aproximare normală',
  'param.show-continuity-bins.label': 'Arată corecția de continuitate',
  'param.speed.label': 'Viteza auto-drop',
  'btn.drop-one': 'Drop 1',
  'btn.drop-100': 'Drop 100',
  'btn.drop-1000': 'Drop 1000',
  'btn.auto-drop': 'Auto-drop',
  'experiment.sums-of-iid.info':
    'Explorează suma și media variabilelor aleatoare independente identic distribuite',
  'submode.sums-of-iid.uniform.label': 'Uniform [-1,1]',
  'submode.sums-of-iid.exponential.label': 'Exponențial (λ=1)',
  'submode.sums-of-iid.bimodal.label': 'Bimodal',
  'submode.sums-of-iid.discrete-die.label': 'Zar discret',
  'submode.sums-of-iid.custom-3-point.label': 'Personalizat 3-punct',
  'param.base-dist.label': 'Distribuție de bază',
  'param.somregel.label': 'Arată formulele somregel',
  'param.standardize.label': 'Standardizare',
  'param.sum-or-mean.label': 'Sumă sau medie',
  'formula.somregel.mu': 'μ_S = n·μ',
  'formula.somregel.sigma-squared': 'σ²_S = n·σ²',
  'formula.somregel.sigma': 'σ_S = σ·√n',
  'btn.draw-100': 'Extrage 100',
  'btn.draw-1000': 'Extrage 1000',
  'btn.draw-10000': 'Extrage 10000',
  'btn.auto-draw': 'Auto-extrage',
  'experiment.normal-calculator.info': 'Explorează distribuția normală și corecția de continuitate',
  'submode.normal-calculator.density.label': 'Densitate',
  'submode.normal-calculator.bin-approx.label': 'Aproximare binomială',
  'param.region-type.label': 'Tip regiune',
  'param.mu.label': 'Media (μ)',
  'param.sigma.label': 'Deviație standard (σ)',
  'param.a-bound.label': 'Limita inferioară (a)',
  'param.b-bound.label': 'Limita superioară (b)',
  'param.show-z-scores.label': 'Arată scoruri Z',
  'param.show-68-95-99.label': 'Arată benzile 68-95-99.7',
  'param.show-continuity-correction.label': 'Arată corecția de continuitate',
  'region.between.label': 'Între (a ≤ X ≤ b)',
  'region.leq.label': 'Mai mic sau egal (X ≤ a)',
  'region.geq.label': 'Mai mare sau egal (X ≥ a)',
  'region.tails.label': 'Cozi (|X| ≥ a)',
  'experiment.classic-problems.info':
    'Explorează Monty Hall, paradoxul zilei de naștere și acul Buffon',
  'submode.classic-problems.monty-hall.label': 'Problema Monty Hall',
  'submode.classic-problems.birthday.label': 'Paradoxul zilei de naștere',
  'submode.classic-problems.buffon.label': 'Acul Buffon',
  'param.strategy.label': 'Strategie',
  'param.class-size.label': 'Dimensiunea clasei (n)',
  'param.needle-length.label': 'Lungimea acului (ℓ)',
  'param.show-formula.label': 'Arată formula',
  'strategy.switch.label': 'Schimbare',
  'strategy.stay.label': 'Rămâi',
  'strategy.random.label': 'Aleator',
  'btn.play-1': 'Joacă 1',
  'btn.play-100': 'Joacă 100',
  'btn.play-10000': 'Joacă 10000',
  'stat.win-rate.switch': 'Rată de câștig schimbare',
  'stat.win-rate.stay': 'Rată de câștig rămâi',
  'stat.empirical-prob': 'Empiric P',
  'stat.theoretical-prob': 'Teoretic P',
  'stat.pi-estimate': 'Estimare π',
  'axis.outcome': 'Rezultat',
  'axis.probability': 'Probabilitate',
  'axis.probability-cumulative': 'Probabilitate cumulativă',
  'axis.value': 'Valoare',
  'axis.density': 'Densitate',
  'axis.count-bin': 'Interval',
  'axis.count': 'Număr',
  'venn.set.A': 'A',
  'venn.set.B': 'B',
  'venn.set.C': 'C',
  'param.intersection.label': 'Mărimea intersecției',
  'spinner.legend.sector': 'Sector',
};
